import React from 'react'
import PropTypes from 'prop-types'
import SingleDeskHourExceptionInput from './SingleDeskHourExceptionInput'
import GenericManyInput from '../../GenericManyInput'

const initialGeneralAvailabilityModel = {date: '', openTime: null, closeTime: null, isClosedAllDay: false}

function ManyDeskHourExceptionInput(props) {
  return (
    <GenericManyInput
      onChange={props.onChange}
      value={props.value}
      emptyModel={initialGeneralAvailabilityModel}
      singleInputComponent={SingleDeskHourExceptionInput}
      error={props.error}
      validator={validateObject}
    />
  )
}

ManyDeskHourExceptionInput.propTypes = {
  onChange: PropTypes.func.isRequired, // returns the array of GeneralAvailability objects
  value: PropTypes.arrayOf(SingleDeskHourExceptionInput.propTypes.value), // an array of GeneralAvailabilityModal
}

export default ManyDeskHourExceptionInput

function validateObject(obj) {
  console.log('validating', obj)
  if (!obj.date) {
    return false
  }
  if (obj.isClosedAllDay) {
    return true
  }

  if (typeof obj.openTime !== 'number' || typeof obj.closeTime !== 'number') {
    return false
  }

  return obj.openTime < obj.closeTime
}
